export default "__VITE_ASSET__BH9bxT9o__"